import * as React from 'react';

const HeadingLevelContext = React.createContext({
    level: 1,
});
/**
 * Increments the current heading level by 1.
 */
const HeadingLevelProvider = ({ children, root }) => {
    const { level } = React.useContext(HeadingLevelContext);
    const nextLevel = (level === 6 ? level : level + 1);
    return (React.createElement(HeadingLevelContext.Provider, { value: { level: root ? 1 : nextLevel } }, children));
};

export { HeadingLevelContext, HeadingLevelProvider };
